module.exports = "pegasus/assets/email1-facebook-icon.png";